import React, { useState, useEffect } from 'react'
import { Layout, Menu, Avatar, Dropdown, Badge, Spin } from 'antd'
import {
  HomeOutlined, BarChartOutlined, ToolOutlined, TeamOutlined,
  FileTextOutlined, BellOutlined, LogoutOutlined, AppstoreOutlined,
  MenuFoldOutlined, MenuUnfoldOutlined, CalendarOutlined, PlusOutlined,
  GlobalOutlined, TrophyOutlined, ReadOutlined, StockOutlined,
  DollarOutlined, QrcodeOutlined, DashboardOutlined, ThunderboltOutlined,
  FundOutlined, PieChartOutlined, LineChartOutlined, AreaChartOutlined,
  ExperimentOutlined, RocketOutlined, ApiOutlined, CodeOutlined,
  PictureOutlined,
} from '@ant-design/icons'
import { Input, Modal, Radio } from 'antd'
import { useNavigate, useLocation, Outlet, Navigate } from 'react-router-dom'
import { useAuth } from '../store/auth'
import { dashboardTabs, toolTabs, opsBackends } from '../api'

const { Sider, Header, Content } = Layout

const ALL_MENU = [
  { key: '/', moduleKey: 'home', icon: <HomeOutlined />, label: '首页' },
  {
    key: '__ops_backends', moduleKey: '', icon: <AppstoreOutlined />, label: '运营常用后台',
    children: [
      { key: '__ext_zcadmin', label: '足彩后台', icon: <TrophyOutlined style={{ color: '#FF6B35' }} />, external: 'https://admin-pay.xiaohongdan.com/admin' },
      { key: '__ext_article', label: '文章&运营后台', icon: <ReadOutlined style={{ color: '#536DFE' }} />, external: 'https://dadmin.dongqiudi.com/admin/login' },
      { key: '__ext_jcgw', label: '竞彩官网', icon: <StockOutlined style={{ color: '#31C2A0' }} />, external: 'https://www.sporttery.cn/jc/zqszsc/' },
      { key: '__ext_500', label: '500.com', icon: <DollarOutlined style={{ color: '#FFC260' }} />, external: 'https://www.500.com/' },
      { key: '__ext_qrcode', label: '草料二维码', icon: <QrcodeOutlined style={{ color: '#9C27B0' }} />, external: 'https://cli.im/text' },
    ],
  },
  { key: '__ext_bdq', moduleKey: '', icon: <GlobalOutlined />, label: '不懂球数据中心', external: 'https://budongqiudi.com/' },
  { key: '__ext_work', moduleKey: '', icon: <GlobalOutlined />, label: 'Work项目平台', external: 'https://work.dongqiu.org/dashboard/overview' },
  { key: '/dashboard', moduleKey: 'dashboard', icon: <BarChartOutlined />, label: '数据看板' },
  { key: '/tools', moduleKey: 'tools', icon: <ToolOutlined />, label: '运营工具' },
  { key: '/help', moduleKey: 'help', icon: <FileTextOutlined />, label: '常用文档中心' },
  { key: '/assets', moduleKey: 'help', icon: <PictureOutlined />, label: '常用素材和字体' },
  { key: '/schedule', moduleKey: '', icon: <CalendarOutlined />, label: '排班系统' },
  { key: '/users', moduleKey: 'users', icon: <TeamOutlined />, label: '用户管理' },
]

export default function MainLayout() {
  const [collapsed, setCollapsed] = useState(false)
  const { user, loading, logout, can } = useAuth()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [dbTabs, setDbTabs] = useState<{id: number; name: string; url: string}[]>([])
  const [toolTabList, setToolTabList] = useState<{id: number; name: string; url: string; open_mode?: string}[]>([])
  const [opsList, setOpsList] = useState<{id: number; name: string; url: string; open_mode?: string}[]>([])
  const [addModalOpen, setAddModalOpen] = useState(false)
  const [addModalType, setAddModalType] = useState<'dashboard' | 'tools' | 'ops'>('dashboard')
  const [addForm, setAddForm] = useState({ name: '', url: '', owner: '', description: '', open_mode: 'iframe' })

  const fetchTabs = () => {
    dashboardTabs.list().then((data: any) => setDbTabs(data)).catch(() => {})
    toolTabs.list().then((data: any) => setToolTabList(data)).catch(() => {})
    opsBackends.list().then((data: any) => setOpsList(data)).catch(() => {})
  }

  useEffect(() => { fetchTabs() }, [])


  if (loading) {
    return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Spin size="large" /></div>
  }
  if (!user) return <Navigate to="/login" replace />

  const menuItems: any[] = ALL_MENU.filter(m => can(m.moduleKey)).map(m => {
    if (m.key === '__ops_backends') {
      const dynamicOpsIcons = [
        <GlobalOutlined style={{ color: '#31C2A0' }} />,
        <GlobalOutlined style={{ color: '#FF6B35' }} />,
        <GlobalOutlined style={{ color: '#536DFE' }} />,
        <GlobalOutlined style={{ color: '#FFC260' }} />,
        <GlobalOutlined style={{ color: '#9C27B0' }} />,
      ]
      return {
        key: m.key,
        icon: m.icon,
        label: m.label,
        children: [
          ...(m as any).children.map((c: any) => ({ key: c.key, icon: c.icon, label: c.label })),
          ...opsList.map((o, i) => ({
            key: `__ops_dyn_${o.id}`,
            icon: dynamicOpsIcons[i % dynamicOpsIcons.length],
            label: o.name,
          })),
          { key: '__ops_backends/__add', icon: <PlusOutlined />, label: '新增' },
        ],
      }
    }
    if (m.key === '/dashboard') {
      return {
        key: m.key,
        icon: m.icon,
        label: m.label,
        children: [
          ...dbTabs.map((t, i) => {
            const icons = [
              <FundOutlined style={{ color: '#536DFE' }} />,
              <PieChartOutlined style={{ color: '#31C2A0' }} />,
              <LineChartOutlined style={{ color: '#FF6B35' }} />,
              <AreaChartOutlined style={{ color: '#9C27B0' }} />,
              <DashboardOutlined style={{ color: '#FFC260' }} />,
            ]
            return { key: `/dashboard/${t.id}`, icon: icons[i % icons.length], label: t.name }
          }),
          {
            key: '/dashboard/__add',
            icon: <PlusOutlined />,
            label: '新增看板',
          },
        ],
      }
    }
    if (m.key === '/tools') {
      return {
        key: m.key,
        icon: m.icon,
        label: m.label,
        children: [
          ...toolTabList.map((t, i) => {
            const icons = [
              <ThunderboltOutlined style={{ color: '#FFC260' }} />,
              <RocketOutlined style={{ color: '#FF6B35' }} />,
              <ExperimentOutlined style={{ color: '#9C27B0' }} />,
              <ApiOutlined style={{ color: '#31C2A0' }} />,
              <CodeOutlined style={{ color: '#536DFE' }} />,
            ]
            return { key: `/tools/${t.id}`, icon: icons[i % icons.length], label: t.name }
          }),
          {
            key: '/tools/__add',
            icon: <PlusOutlined />,
            label: '新增工具',
          },
        ],
      }
    }
    return { key: m.key, icon: m.icon, label: m.label }
  })

  const selectedKey = pathname.startsWith('/dashboard/') ? pathname : (pathname.startsWith('/tools/') ? pathname : (ALL_MENU.find(m => m.key !== '/' && pathname.startsWith(m.key))?.key ?? '/'))
  const currentModule = ALL_MENU.find(m => m.key !== '/' && pathname.startsWith(m.key))?.moduleKey ?? 'home'

  if (!can(currentModule) && menuItems.length > 0) {
    return <Navigate to={menuItems[0].key} replace />
  }
  if (menuItems.length === 0) {
    return <div style={{ padding: 24, color: '#999' }}>当前账号无任何模块访问权限，请联系管理员授权</div>
  }

  const isDashboardTab = !!pathname.match(/^\/dashboard\/\d+/)
  const isToolTab = !!pathname.match(/^\/tools\/\d+/)
  const isSchedule = pathname === '/schedule'
  const isFullscreenTab = isDashboardTab || isToolTab || isSchedule

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {/* Sidebar: fully hidden when collapsed on dashboard tab */}
      {!(collapsed && isFullscreenTab) && (
        <Sider collapsible collapsed={false} trigger={null}
          width={220}
          className="puc-sidebar"
          style={{ background: '#fff', boxShadow: '2px 0 8px rgba(0,0,0,0.03)', zIndex: 10, display: 'flex', flexDirection: 'column' }}>
          <div style={{
            height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            background: 'linear-gradient(90deg, #536DFE 0%, #798DFE 100%)',
            color: '#fff', fontWeight: 700, fontSize: 17, letterSpacing: 0.5,
            padding: '0 16px',
          }}>
            <span style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>付费运营中心</span>
            {isFullscreenTab && (
              <MenuFoldOutlined
                onClick={() => setCollapsed(true)}
                style={{ fontSize: 16, cursor: 'pointer', color: '#fff' }}
              />
            )}
          </div>
          {/* User info */}
          <div style={{
            padding: '12px 16px',
            borderBottom: '1px solid #f0f0f0',
            display: 'flex', alignItems: 'center', gap: 8,
          }}>
            <Avatar size={32} style={{ background: '#FFC260', color: '#fff', fontWeight: 600, flexShrink: 0 }}>
              {user?.name?.[0] ?? 'U'}
            </Avatar>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#4A4A4A', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{user?.name}</div>
              <a onClick={logout} style={{ fontSize: 12, color: '#999', cursor: 'pointer' }}>退出登录</a>
            </div>
          </div>
          <Menu mode="inline" selectedKeys={[selectedKey]} inlineIndent={8}
            style={{ border: 'none', padding: '12px 8px', flex: 1 }}
            items={menuItems.map(m => ({ ...m, style: { borderRadius: 8, marginBottom: 4 } }))}
            onClick={({ key }) => {
              if (key === '/dashboard/__add') {
                setAddModalType('dashboard')
                setAddModalOpen(true)
                return
              }
              if (key === '/tools/__add') {
                setAddModalType('tools')
                setAddModalOpen(true)
                return
              }
              if (key === '__ops_backends/__add') {
                setAddModalType('ops')
                setAddForm({ name: '', url: '', owner: '', description: '', open_mode: 'new_window' })
                setAddModalOpen(true)
                return
              }
              const dynOpsMatch = key.match(/^__ops_dyn_(\d+)$/)
              if (dynOpsMatch) {
                const item = opsList.find(o => o.id === Number(dynOpsMatch[1]))
                if (item) {
                  if (item.open_mode === 'iframe') {
                    navigate(`/ops-iframe/${item.id}`)
                  } else {
                    window.open(item.url, '_blank')
                  }
                }
                return
              }
              const extItem = ALL_MENU.find(m => m.key === key && (m as any).external)
              if (extItem) {
                window.open((extItem as any).external, '_blank')
                return
              }
              const opsBackendsMenu = ALL_MENU.find(m => m.key === '__ops_backends') as any
              const opsChild = opsBackendsMenu?.children?.find((c: any) => c.key === key)
              if (opsChild) {
                if (opsChild.external) {
                  window.open(opsChild.external, '_blank')
                } else if (opsChild.route) {
                  navigate(opsChild.route)
                }
                return
              }
              const toolMatch = key.match(/^\/tools\/(\d+)$/)
              if (toolMatch) {
                const tab = toolTabList.find(t => t.id === Number(toolMatch[1]))
                if (tab && tab.open_mode === 'new_window') {
                  window.open(tab.url, '_blank')
                  return
                }
              }
              navigate(key)
            }} />
          {/* Collapse toggle removed - now in top bar */}
        </Sider>
      )}
      <Layout style={{ background: '#F6F7FF' }}>
        <Content style={{ margin: collapsed && isFullscreenTab ? 0 : 24, minHeight: 280 }}>
          <Outlet context={{ collapsed, setCollapsed }} />
        </Content>
      </Layout>
      <Modal
        title={addModalType === 'dashboard' ? '新增看板' : addModalType === 'ops' ? '新增常用后台' : '新增运营工具'} open={addModalOpen}
        onOk={async () => {
          if (!addForm.name.trim() || !addForm.url.trim()) return
          if (addModalType === 'ops') {
            await opsBackends.create({ name: addForm.name.trim(), url: addForm.url.trim(), description: addForm.description.trim(), open_mode: addForm.open_mode })
            setAddForm({ name: '', url: '', owner: '', description: '', open_mode: 'new_window' })
            setAddModalOpen(false)
            fetchTabs()
            return
          }
          const api = addModalType === 'dashboard' ? dashboardTabs : toolTabs
          const payload: any = { name: addForm.name.trim(), url: addForm.url.trim(), owner: addForm.owner.trim(), description: addForm.description.trim() }
          if (addModalType === 'tools') payload.open_mode = addForm.open_mode
          const created: any = await api.create(payload)
          setAddForm({ name: '', url: '', owner: '', description: '', open_mode: 'iframe' })
          setAddModalOpen(false)
          fetchTabs()
          if (addModalType === 'tools' && addForm.open_mode === 'new_window') {
            window.open(addForm.url.trim(), '_blank')
          } else {
            navigate(addModalType === 'dashboard' ? `/dashboard/${created.id}` : `/tools/${created.id}`)
          }
        }}
        onCancel={() => setAddModalOpen(false)}
        okText="添加" cancelText="取消"
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <Input placeholder={addModalType === 'ops' ? '名称' : '工具名称'} value={addForm.name} onChange={e => setAddForm(f => ({ ...f, name: e.target.value }))} />
          <Input placeholder="跳转地址（URL）" value={addForm.url} onChange={e => setAddForm(f => ({ ...f, url: e.target.value }))} />
          {addModalType !== 'ops' && <Input placeholder="负责人" value={addForm.owner} onChange={e => setAddForm(f => ({ ...f, owner: e.target.value }))} />}
          <Input placeholder="简介" value={addForm.description} onChange={e => setAddForm(f => ({ ...f, description: e.target.value }))} />
          {(addModalType === 'tools' || addModalType === 'ops') && (
            <div>
              <div style={{ fontSize: 13, color: '#666', marginBottom: 4 }}>打开方式</div>
              <Radio.Group value={addForm.open_mode} onChange={e => setAddForm(f => ({ ...f, open_mode: e.target.value }))}>
                <Radio value="iframe">PUC中心打开</Radio>
                <Radio value="new_window">新窗口打开</Radio>
              </Radio.Group>
            </div>
          )}
        </div>
      </Modal>
    </Layout>
  )
}
